import Vue from 'vue'

const modify = function (val, type) {
  if (!isNaN(val)) {
    return val + type
  }
  return val
}

const camelToKebabCase = function (str) {
  return str ? str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() : str
}

const logic = function (el, binding, vnode) {

  const propName = binding.arg
  const modifiers = binding.modifiers
  const values = binding.value
  let propValue = values

  if(propName){
    let priority = ''
    for (const modifier in modifiers) {
      if (modifier === '!important') {
        priority = 'important'
      } else {
        propValue = modify(propValue, modifier)
      }
    }

    el.style.setProperty(camelToKebabCase(propName), propValue, priority)
  }

}

Vue.directive('style', {
  inserted: logic,
  update: logic
})
